// AGC: One-key sugar over useSubscriptionCapabilities.
// AGC: Use when a component only needs a single capability flag.

import { useSubscriptionCapabilities, SubscriptionCapabilities } from './useSubscriptionCapabilities'

export function useCapability<K extends keyof SubscriptionCapabilities>(key: K): SubscriptionCapabilities[K] {
  const caps = useSubscriptionCapabilities()
  return caps[key]
}
